import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

const NotFound: React.FC = () => (
  <div className="terms-page">
    <div className="terms-content">
      <h1>Page not found</h1>
      <p>
        We could not find that page. Return to the{' '}
        <Link to="/">Heal home</Link>
        , read our <Link to="/terms">Terms</Link> or <Link to="/privacy">Privacy</Link> policy, or contact{' '}
        <a href="mailto:info@healmusicapp.com">info@healmusicapp.com</a>.
      </p>
    </div>
  </div>
);

export default NotFound;
